// src/components/FRPFilterPage.jsx
import React from "react";
import "./FRP.css";
import { Link } from "react-router-dom";
export default function FRPFilterPage() {
  return (
    <div className="frp-page">

      {/*  Hero section */}
     <section className="hero-frp" style={{ backgroundImage: "url('/images/FRP.png')" }}>
  <div className="hero-frp-overlay"></div>
  <div className="hero-frp-content">
    <h1 className="hero-frp-title">FRP – Pressure Sand Filter</h1>
    <p className="hero-frp-subtitle">
      Reliable Filtration for Industrial & Domestic Use
    </p>
    <div className="cta-frp-buttons">
      <Link to="/contact"><button className="btn-frp-primary">Request a Quote</button></Link>
      <button className="btn-frp-secondary">Download Brochure</button>
    </div>
  </div>
</section>

      {/* Description */}
      <section className="frp-description">
  <div className="frp-description-text">
    <h2>Description</h2>
    <p>
      Crystal Drops FRP Pressure Sand Filters are engineered with precision to
      deliver reliable water treatment. Using specially graded sand media,
      these filters effectively remove suspended solids, turbidity, and
      impurities, ensuring clear and safe water for both industrial and
      domestic applications.
    </p>
  </div>
  <div className="frp-description-image">
    <img src="/images/FRP-1.png" alt="FRP Pressure Sand Filter" />
  </div>
</section>

      {/* Applications Grid */}
   <section className="applications">
  <h2>Where It Works</h2>
  <div className="applications-grid">
    <div className="application-card">
      <span className="application-icon">💧</span>
      <h3>Drinking Water Supplies</h3>
      <p>Ensures safe, clear water for communities and households.</p>
    </div>
    <div className="application-card">
      <span className="application-icon">🏠🏭</span>
      <h3>Domestic & Industrial Water</h3>
      <p>Reliable filtration for both home and industrial systems.</p>
    </div>
    <div className="application-card">
      <span className="application-icon">🏊</span>
      <h3>Swimming Pools</h3>
      <p>Maintains crystal-clear pool water by removing impurities.</p>
    </div>
    <div className="application-card">
      <span className="application-icon">🚰</span>
      <h3>Bottled Water Plants</h3>
      <p>Supports high-quality bottled water production.</p>
    </div>
    <div className="application-card">
      <span className="application-icon">⚙️</span>
      <h3>RO Plant Pre-treatment</h3>
      <p>Prepares feed water for reverse osmosis systems.</p>
    </div>
    <div className="application-card">
      <span className="application-icon">🏭</span>
      <h3>Industrial Water Treatment</h3>
      <p>Removes suspended solids for process and utility water.</p>
    </div>
  </div>
</section>

      {/* Advantages Cards */}
 <section className="frp-advantages">
  <h2 className="frp-heading">Key Benefits of Crystal Drops</h2>
  <div className="frp-advantages-flow">
    <div className="frp-step">
      <span className="frp-step-number">1</span>
      <p>⚖️ Lightweight & Easy to Lift</p>
    </div>
    <div className="frp-step">
      <span className="frp-step-number">2</span>
      <p>👌 User-Friendly Operation</p>
    </div>
    <div className="frp-step">
      <span className="frp-step-number">3</span>
      <p>🔧 Maintenance-Free</p>
    </div>
    <div className="frp-step">
      <span className="frp-step-number">4</span>
      <p>✅ Pre-assembled & Tested</p>
    </div>
    <div className="frp-step">
      <span className="frp-step-number">5</span>
      <p>🔀 Single Lever Multi-port Valve</p>
    </div>
    <div className="frp-step">
      <span className="frp-step-number">6</span>
      <p>⚙️ Simplified Valve Operation</p>
    </div>
  </div>
</section>

      {/* Technical Specs Accordion */}
      <section className="specs">
        <h2>Technical Specifications</h2>
        <ul>
          <li>FRP Pressure Vessel</li>
          <li>PVC Piping & Multi-port Valve</li>
          <li>Graded Sand Media + Underbed</li>
          <li>Inlet, Outlet, Drain, Backwash Line</li>
          <li>Mounted on MS Stand</li>
        </ul>
      </section>

      {/* Final CTA */}
      <section className="frp-final-cta">
  <div className="frp-final-cta-content">
    <h2 className="frp-final-cta-heading">Ready to Upgrade Your Water Filtration?</h2>
    <p className="frp-final-cta-subtext">
      Crystal-clear water is just one step away.
    </p>
    <div className="frp-final-cta-buttons">
      <button className="frp-btn-primary">Contact Us</button>
    </div>
  </div>
</section>
    </div>
  );
}